// Configuration
const TRIGGER_PRODUCTS = ['coco', 'coco-1', 'le-bisou', 'coco-x-toupie', 'coffret-self-love', 'coco-deluxe-edition', 'coco-x-chouchou', 'chouchou-deluxe-edition', 'orgasmic-edition', 'coffret-chouchou-premium'];
const PROMO_CODE = 'FREE_COURSE';
const GIFT_HANDLE = 'back-to-basics';

/**
 * Gère l'ajout automatique d'un produit cadeau et l'application d'un code promo
 * @param {Object} variant - La variante du produit ajouté au panier
 * @returns {Promise<void>}
**/

async function handleGiftProductAndPromo(variant) {

  if (!TRIGGER_PRODUCTS.includes(variant.handle)) {
    return;
  }

  try {
    // Récupère le merchandiseId du produit cadeau
    const giftProductQuery = `
      query getGiftProduct($handle: String!) {
        product(handle: $handle) {
          variants(first: 1) {
            edges {
              node {
                id
              }
            }
          }
        }
      }
    `;

    const giftProduct = await window.DeployerStorefrontApi.request(giftProductQuery, {
      handle: GIFT_HANDLE
    });

    if (!giftProduct.product?.variants?.edges?.[0]?.node?.id) {
      console.error('❌ Produit cadeau non trouvé');
      return;
    }

    const giftVariantId = giftProduct.product.variants.edges[0].node.id;

    // Mutation pour ajouter au panier
    const addToCartMutation = `
      mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
        cartLinesAdd(cartId: $cartId, lines: $lines) {
          cart {
            id
            lines(first: 10) {
              edges {
                node {
                  id
                  quantity
                  merchandise {
                    ... on ProductVariant {
                      id
                      title
                    }
                  }
                }
              }
            }
          }
          userErrors {
            field
            message
          }
        }
      }
    `;

    // Récupère l'ID du panier
    const cartResponse = await fetch('/cart.js');
    const cartData = await cartResponse.json();
    const cartId = `gid://shopify/Cart/${cartData.token}`;
    
    // Ajoute le produit cadeau
    const addToCartResult = await window.DeployerStorefrontApi.request(addToCartMutation, {
      cartId: cartId,
      lines: [
        {
          merchandiseId: giftVariantId,
          quantity: 1
        }
      ]
    });
    
    if (addToCartResult.cartLinesAdd.userErrors.length > 0) {
      console.error('❌ Erreur lors de l\'ajout du produit:', addToCartResult.cartLinesAdd.userErrors);
      return;
    }

    // Applique le code promo
    const result = await window.DeployerStorefrontApi.applyDiscountCode(PROMO_CODE);
    
    if (result.cartDiscountCodesUpdate.userErrors.length > 0) {
      console.error('❌ Erreur lors de l\'application du code promo:', result.cartDiscountCodesUpdate.userErrors);
      return;
    }

    // Rafraîchit le panier
    const updatedCartResponse = await fetch('/cart.js');
    const updatedCartData = await updatedCartResponse.json();
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { cart: updatedCartData }
    }));

  } catch (error) {
    console.error('❌ Erreur lors du processus:', error);
  }
} 

window.handleGiftProductAndPromo = handleGiftProductAndPromo;